import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import useSuggestTextLogic from './useSuggestTextLogic';

const StyledHighlight = styled.span`
  color: ${props => props.theme.text.normal};
  font-weight: 700;
`;

const SuggestText = ({ fieldId, highlightMatch, suggestLabel }) => {
  const { matchedChars, showMatch, unmatchedChars } = useSuggestTextLogic({
    fieldId,
    suggestLabel,
  });
  if (!highlightMatch || !showMatch) return <>{suggestLabel}</>;
  return (
    <>
      <StyledHighlight>{matchedChars}</StyledHighlight>
      {unmatchedChars}
    </>
  );
};

const suggestTextPropTypes = {
  fieldId: PropTypes.string.isRequired,
  highlightMatch: PropTypes.bool,
  suggestLabel: PropTypes.string.isRequired,
};
const suggestTextDefaultProps = {
  highlightMatch: false,
};

SuggestText.propTypes = suggestTextPropTypes;
SuggestText.defaultProps = suggestTextDefaultProps;
export default SuggestText;
export { suggestTextDefaultProps, suggestTextPropTypes };
